import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SmallAndAbove } from '@lichtblick/theme';
import styled, { css } from 'styled-components';
const imageStyle = css`
  max-width: 100%;
  vertical-align: middle;
`;
export const StyledImage = styled.picture`
  ${imageStyle}
`;
const Img = styled.img`
  ${imageStyle}
`;
export const Image = ({ description, url, ...pictureProps })=>/*#__PURE__*/ _jsxs(StyledImage, {
        ...pictureProps,
        children: [
            url.desktop && /*#__PURE__*/ _jsx("source", {
                media: SmallAndAbove,
                srcSet: url.desktop
            }),
            /*#__PURE__*/ _jsx(Img, {
                alt: description,
                loading: "lazy",
                src: url.mobile
            })
        ]
    });

//# sourceMappingURL=Image.js.map